import React from 'react';
import { Box, Heading, SimpleGrid } from '@chakra-ui/react';
import { ToolCard } from './ToolCard';
import { motion } from 'framer-motion';
const MotionBox = motion(Box);
const tools = [{
  name: 'ChatGPT',
  description: 'My main tool. I keep folders for different projects and use custom models when I need to connect to other tools. The agent mode is great when I need it to do research or handle tasks on its own.',
  features: ['Organized folders for each project', 'Custom models with external tools'],
  link: 'https://chat.openai.com/'
}, {
  name: 'Perplexity & Comet',
  description: 'Sometimes I want a different take on things. Perplexity gives me that. Comet is handy for automating browser stuff and pulling out key points from long content.',
  features: ['Browser automation & summarization', 'Alternative perspective & insights'],
  link: 'https://perplexity.ai/pro?referral_code=W4DJUBF4'
}, {
  name: 'Firebase Studio',
  description: "My favorite for building actual apps. It handles auth well and I can iterate forever until I get it right. Plus it plays nice with Google's stuff.",
  features: ['Google ecosystem & Auth', 'Endless iterations, great outputs'],
  link: 'https://firebase.google.com/products/studio'
}, {
  name: 'Lovable',
  description: 'Makes nice-looking React apps. I bounce between this and other tools when starting projects.',
  features: ['Beautiful UI components', 'Part of my multi-tool workflow'],
  link: 'https://lovable.dev/invite/HDGMFGI'
}, {
  name: 'Bolt.new',
  description: 'Good for quick prototypes. When I start something new, I usually try it in a few different tools to see what sticks.',
  features: ['Quick prototypes & iterations', 'Part of my multi-tool workflow'],
  link: 'https://bolt.new/?rid=3gxcrb'
}, {
  name: 'Replit',
  description: 'Another one I use for new projects. Nice for getting from idea to something deployed quickly.',
  features: ['From idea to deployed app', 'Part of my multi-tool workflow'],
  link: 'https://replit.com/refer/randulamartin'
}, {
  name: 'Google Notebook LM',
  description: "Google's research tool. Helpful for digging into documents and finding connections.",
  features: ['AI-powered research assistant', 'Deep document analysis'],
  link: 'https://notebooklm.google/'
}, {
  name: 'Wispr Flow',
  description: "Voice dictation that actually works. I talk instead of type now. It's about 4x faster once you get used to it.",
  features: ['4x faster than typing', 'Fast, accurate voice-to-text'],
  link: 'https://wisprflow.ai/r?MARTIN445'
}, {
  name: 'Superhuman',
  description: "Email client that's stupid fast. The AI features help me get through my inbox without losing my mind.",
  features: ['10x faster email workflow', 'AI-powered email assistance'],
  link: 'https://superhuman.com/refer/4r53d158'
}];
export function ToolsSection() {
  return <Box id="tools" as="section" py={10} data-id="element-150">
      <MotionBox initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} viewport={{
      once: true
    }} data-id="element-151">
        <Heading as="h2" size="xl" mb={8} textAlign="center" data-id="element-152">
          9 AI Tools I Use Daily
        </Heading>
        <SimpleGrid columns={{
        base: 1,
        md: 2,
        lg: 3
      }} spacing={6} data-id="element-153">
          {tools.map((tool, index) => <MotionBox key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} viewport={{
          once: true
        }} data-id="element-154">
              <ToolCard name={tool.name} description={tool.description} features={tool.features} link={tool.link} index={index} isFeatured={index < 3} data-id="element-155" />
            </MotionBox>)}
        </SimpleGrid>
      </MotionBox>
    </Box>;
}